export const environment = {
  url: {
    api: `https://apim-uat.houseofhr.com/square-app-tmi/api/v2.0`,
  },
  production: true,
  ocpApimSubscriptionKey: 'b06a67e5cb5d488cb975e10878e41439'
};

